<div
  class="calc-table position-relative break-inside-avoid"
  *ngIf="{
    internalModel: internalModel$ | async,
    tableColumns: props.tableColumns | castObservable | async,
    mobileLabels: props.mobileLabels | castObservable | async,
    summaryMobileLabels: props.summary?.mobileLabels | castObservable | async
  } as tmplData"
>
  <p *ngIf="props.description" class="mb-2" [innerHtml]="props.description"></p>
  <span *ngIf="props.label" class="bold">{{ props.label }}</span>

  <div
    *ngIf="props.tableRows[0]"
    class="table w-100"
    [class.calc-table--quint]="props.tableRows[0].fields.length === 5"
    [class.calc-table--quad]="props.tableRows[0].fields.length === 4"
    [class.calc-table--triple]="props.tableRows[0].fields.length === 3"
    [class.calc-table--double]="props.tableRows[0].fields.length === 2"
    [class.calc-table--wide-label]="props.wideLabel"
    [class.calc-table--compact-label]="props.compactLabel"
    [class.calc-table--full-width-label]="props.fullWidthLabel"
    [class.calc-table--forced-mobile-view]="props.forceMobileView"
  >
    <div
      *ngIf="tmplData.tableColumns"
      class="calc-table__header bold"
      [ngClass]="{
        'calc-table__header--wide-label': props.wideLabel,
        'calc-table__header--double': tmplData.tableColumns.length === 3,
        'calc-table__header--forced-mobile-view': props.forceMobileView
      }"
    >
      <div class="calc-table__key">
        {{ tmplData.tableColumns[0] }}
      </div>
      <div class="calc-table__value">
        <ng-container
          *ngFor="let column of tmplData.tableColumns; let first = first"
        >
          <div *ngIf="!first">
            {{ column }}
          </div>
        </ng-container>
      </div>
    </div>

    <div
      class="calc-table__row-wrapper d-grid"
      [class.calc-table__row-wrapper--condensed]="props.condensed"
    >
      <ng-container
        *ngFor="let row of props.tableRows | calcTableRows; index as index"
      >
        <ng-container *ngIf="!row.tableRow.hidden">
          <div
            class="calc-table__row break-inside-avoid"
            [class.calc-table__row--title]="row.tableRow.isTitle"
            [ngClass]="row.meta.classList"
          >
            <div
              class="calc-table__key"
              [class.calc-table__key--span-across]="row.tableRow.spanAcross"
            >
              <div
                class="bold text-break-line"
                [innerHTML]="row.tableRow.label"
              ></div>
              <div class="calc-table__tooltip d-flex d-print-none">
                <lui-avatar
                  *ngIf="row.tableRow.tooltip"
                  class="ms-1"
                  color="primary"
                  size="20px"
                  [matTooltip]="row.tableRow.tooltip"
                  [useClickListener]="true"
                >
                  <mat-icon svgIcon="i"></mat-icon>
                </lui-avatar>
              </div>
            </div>
            <div
              *ngIf="!row.tableRow.spanAcross"
              class="calc-table__value d-flex"
              [class.calc-table__value--tooltip]="!!row.tableRow.tooltip"
            >
              <ng-container
                *ngrxLet="
                  tmplData.mobileLabels?.length
                    ? tmplData.mobileLabels
                    : (tmplData.tableColumns | tail) as mobileLabels
                "
              >
                <div
                  *ngIf="mobileLabels.length"
                  class="calc-table__mobile-labels d-flex flex-column d-md-none"
                  [ngClass]="{
                    'calc-table__mobile-labels--forced-mobile-view':
                      props.forceMobileView
                  }"
                >
                  <div
                    *ngFor="let label of mobileLabels"
                    class="calc-table__mobile-label flex-1 pe-1"
                  >
                    {{ label }}
                  </div>
                </div>
              </ng-container>
              <formly-form
                class="w-100"
                [options]="options | cloneDeep"
                [form]="$any(internalForm.at(index))"
                [fields]="row.tableRow.fields"
                [model]="tmplData.internalModel"
                (modelChange)="onModelChange()"
              ></formly-form>
            </div>
          </div>
        </ng-container>
      </ng-container>

      <div
        *ngIf="props.summary"
        class="calc-table__row calc-table__row--summary"
        [ngClass]="{
          'calc-table__row--error': hasErrors,
          'calc-table__row--forced-mobile-view': props.forceMobileView
        }"
      >
        <p class="calc-table__key mat-body-strong">
          {{ props.summary.label }}
        </p>
        <div class="calc-table__value-wrapper">
          <div
            *ngFor="let total of totals; let index = index"
            class="calc-table__total"
          >
            <ng-container
              *ngrxLet="
                tmplData.summaryMobileLabels?.length
                  ? tmplData.summaryMobileLabels
                    ? tmplData.mobileLabels?.length
                    : tmplData.mobileLabels
                  : (tmplData.tableColumns | tail) as mobileLabels
              "
            >
              <div
                class="calc-table__mobile-label flex-1 d-flex flex-column mat-small d-md-none"
                *ngIf="mobileLabels?.[index]"
              >
                {{ mobileLabels[index] }}
              </div>
            </ng-container>
            <div
              class="mat-body-strong flex-1 lh-1"
              [class.text-end]="props.forceMobileView"
              *ngIf="total !== null"
            >
              <span *ngIf="props.summary.addonLeft?.[index]">{{
                props.summary.addonLeft[index]
              }}</span
              ><span
                *ngrxLet="
                  props.summary.decimalFormat | castArray as decimalFormat
                "
                >{{
                  total || 0
                    | number : decimalFormat[index] || decimalFormat[0] || '1.2'
                }}</span
              ><span *ngIf="props.summary.addonRight?.[index]">{{
                props.summary.addonRight[index]
              }}</span>
            </div>
          </div>
        </div>
        <div
          *ngIf="props?.summary?.hintLabel"
          [innerHtml]="props.summary.hintLabel"
          class="calc-table__hint-label mat-small mt-1"
        ></div>
      </div>

      <div
        *ngIf="props.bulkSummary"
        class="calc-table__row calc-table__row--summary calc-table__row--bulk-summary"
      >
        <div class="calc-table__key flex-wrap">
          <div class="bold fw-b w-full">
            {{ props.bulkSummary.label }}
          </div>
          <div class="mat-small">
            {{ props.bulkSummary.description }}
          </div>
        </div>
        <div class="calc-table__value-wrapper">
          <div
            *ngFor="let total of bulkTotals; let index = index"
            class="calc-table__total fw-b"
          >
            <div
              class="mat-body-strong d-md-none"
              *ngIf="props.summary.mobileLabels?.[index]"
            >
              {{ props.summary.mobileLabels?.[index] }}
            </div>
            <div
              *ngrxLet="
                props.summary.decimalFormat | castArray as decimalFormat
              "
            >
              <span *ngIf="total && props.summary.addonLeft?.[index]">{{
                props.summary.addonLeft[index]
              }}</span
              >{{
                total
                  ? (total || 0
                    | number
                      : decimalFormat[index] || decimalFormat[0] || '1.2')
                  : ''
              }}<span *ngIf="total && props.summary.addonRight?.[index]">{{
                props.summary.addonRight[index]
              }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <mat-error *ngIf="hasErrors">
    <formly-validation-message [field]="field"></formly-validation-message>
  </mat-error>
</div>
